import * as React from 'react';
import * as url from 'url';
import {
  Renderer,
  RendererComponentProps,
  ContextObserver,
  Resource,
  AuthSession
} from '../../../webana';
import { observer } from 'mobx-react';
import { Subscriber, Broadcast } from 'react-broadcast';

interface CommissionDetailConfig {
  content?: string;
  style?: React.CSSProperties;
  className?: string;
}

interface CommissionDetailState {
  editingForm?: string;
  loadingPDF?: string;
}

@observer
export class CommissionDetailComponent extends React.Component<
  RendererComponentProps<CommissionDetailConfig> & ContextObserver<any>,
  CommissionDetailState
> {
  state = {
    editingForm: undefined,
    loadingPDF: undefined
  };

  render() {

    const { config, context } = this.props;

    const isDisabledForm = (formType: string) => {
      if (typeof this.state.editingForm === 'undefined') {
        return false;
      }
      return this.state.editingForm !== formType;
    };
    const setEditingForm = (formType: string) => {
      if (this.state.editingForm !== formType) {
        this.setState({ editingForm: formType });
      }
    };
    const downloadPDF = async (type: string, resource: Resource) => {
      if (typeof this.state.loadingPDF !== 'undefined') {
        return;
      }
      const res = new Resource({
        dataSource: resource.dataSource,
        fields: [type],
        id: resource.id,
        name: resource.name
      });

      this.setState({ loadingPDF: type });

      try {
        await res.get();
        let link = res.data[type];
        if (link[0] === '/') {
          link = link.substr(1);
        }
        window.open(
          url.resolve(resource.dataSource.url, link) +
            `?access_token=${AuthSession.current().accessToken}`,
          '_blank'
        );
      } catch (err) {
        console.log(`failed to display PDF due to error: ${err.message}`);
      }
      setTimeout(() => {
        this.setState({ loadingPDF: undefined });
      },         0);
    };

    const ctx = Object.assign({}, context, {
      loadingPDF: this.state.loadingPDF,
      isDisabledForm,
      setEditingForm,
      downloadPDF
    });

    return (
      <div style={config.style} className={config.className}>
        <Broadcast channel="context" value={ctx}>
          <Renderer content={config.content} />
        </Broadcast>
      </div>
    );
  }
}

export class CommissionDetail extends React.Component<
  RendererComponentProps<CommissionDetailConfig>
> {
  render() {
    // console.log("CD", this);

    return (
      <Subscriber channel="context">
        {ctx => <CommissionDetailComponent {...this.props} context={ctx} />}
      </Subscriber>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/sezako/components/CommissionDetail.tsx